import { render, staticRenderFns } from "./team.vue?vue&type=template&id=5822a25f&scoped=true"
import script from "./team.vue?vue&type=script&lang=js"
export * from "./team.vue?vue&type=script&lang=js"
import style0 from "./team.vue?vue&type=style&index=0&id=5822a25f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5822a25f",
  null
  
)

export default component.exports